/*
 *   Copyright (c) 2022 vlinder Labs Private Limited
 *   All rights reserved.
 *   This software is proprietary of Vlinder Labs Pvt. Ltd and can not be distributed / used for any purpose outside of Vlinder Labs Pvt. Ltd without explicit written consent from the copyright owner.
 */
import { LoggerModule } from "@vlinder-web/logger-module-react";
import _ from "lodash";
import { VApplication } from "../application";
import { GraphqlServerModule } from '@vlinder-web/graphql-server-module-react';
import { GET_CERTIFICATES_TABLE } from "../pages/DownloadScreen/graphql";
import { toast } from "react-hot-toast"

const MODULE_NAME = "GetCertificatesTableService";
const log: any = LoggerModule.getInstance();

const getGraphQLModule = () => {
    const app = VApplication.getInstance();
    return app.getSync('services.GraphqlServerModule') as GraphqlServerModule;
};

export class GetCertificatesTableService {
    private static instance: GetCertificatesTableService;
    private vapp: VApplication;
    // private termsURL: string;
    private constructor(props: any = {}) {
        this.vapp = VApplication.getInstance();
        // this.termsURL = props?.termsURL
    }
    public static getInstance(props: any = {}): GetCertificatesTableService {
        if (!GetCertificatesTableService.instance) {
            GetCertificatesTableService.instance = new GetCertificatesTableService(props);
        }
        return GetCertificatesTableService.instance;
    }

    async  getCertificatesTable(limit: number, skip: number, filter: any) {
        const graphqlModule = getGraphQLModule();
        const client = graphqlModule.getClient("graphql-gateway");
        if(!client){
            console.log('graphql-gateway is not available !!!!!!');
        }

        console.log('GetCertificatesTableService()::getCertificatesTable()-> entered here..');

        try {
            if (client) {
                const res = await client.query({
                    query: GET_CERTIFICATES_TABLE,
                    variables: {
                        criteria: filter ,
                        skip: skip,
                        limit: limit
                    },

                    fetchPolicy: "network-only",
                });
                log.success(MODULE_NAME, "getCertificatesTable : ", res?.data);
                if (res?.data?.getCertificateTable) {
                    return res?.data?.getCertificateTable
                }
            }
        } catch (err: any) {
            console.log(err);
            err?.graphQLErrors &&
                Array.isArray(err?.graphQLErrors) &&
                err?.graphQLErrors.length > 0 &&
                toast.error(err?.graphQLErrors[0]?.message);
        }
    }
}
